import { render, staticRenderFns } from "./PromotionEdit.vue?vue&type=template&id=ee188716&scoped=true&"
import script from "./PromotionEdit.vue?vue&type=script&lang=js&"
export * from "./PromotionEdit.vue?vue&type=script&lang=js&"
import style0 from "./PromotionEdit.vue?vue&type=style&index=0&id=ee188716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee188716",
  null
  
)

export default component.exports